export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";